<div class="container" [ngClass]="{'close-nav': !isOpen }">
    <ng-container *ngIf="isAdmin$()">
        <button mat-raised-button color="primary" (click)="createNewOpen=true" class="new_que pointer" #newTrigger>
            <img class="plus" src="/assets/images/plus.svg">
            <p class="txt txt_white" translate>search.new.title</p>
        </button>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="newTrigger"
            [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayOpen]="true"
            cdkConnectedOverlayBackdropClass="backdrop-selection" (backdropClick)="createNewOpen=false"
            [cdkConnectedOverlayOpen]="createNewOpen" [cdkConnectedOverlayPositions]="positonArea">
            <div class="overlay-warp">
                <div class="item" (click)="createNewQuestionnaire()">
                    <img class="icon scale-img" src="/assets/images/grid/questionnaires.svg">
                    <p translate>search.new.newQuestionnaire</p>
                </div>
                <div class="divider"></div>
                <div class="item" (click)="newReminder()">
                    <img class="icon scale-img" src="/assets/images/reminders.svg">
                    <p translate>search.new.newReminder</p>
                </div>
                <div class="item" (click)="newDistrbutionGroup()">
                    <img class="icon scale-img" src="/assets/images/distribution-groups.svg">
                    <p translate>search.new.newGroup</p>
                </div>
                <div class="item" (click)="newSavedList()">
                    <img class="icon scale-img" src="/assets/images/saved-lists.svg">
                    <p translate>search.new.newList</p>
                </div>
            </div>
        </ng-template>
    </ng-container>

    <div class="row hover-with-grediant pointer" (click)="navigate('questionnaires')"
        [ngClass]="{'category-choose select-with-grediant': lastUrlSegment == 'questionnaires' }">
        <div class="name">
            <img class="icon scale-img" src="/assets/images/grid/questionnaires.svg">
            <p translate>grid.navs.questionnaires</p>
        </div>
    </div>
    <div class="row hover-with-grediant pointer" (click)="navigate('distributionGroups')" *ngIf="isAdmin$()"
        [ngClass]="{'category-choose select-with-grediant': lastUrlSegment == 'distributionGroups' }">
        <div class="name">
            <img class="icon scale-img" src="/assets/images/distribution-groups.svg">
            <p translate>grid.navs.distributionGroups</p>
        </div>
    </div>
    <!-- <div class="row pointer" [routerLink]="['smartQuestions']" *ngIf="isAdmin$()"
        [ngClass]="{'category-choose': lastUrlSegment == 'smartQuestions' }">
        <div class="name">
            <img class="icon" src="/assets/images/smart-questions.svg">
            <p translate>grid.navs.smartQuestions</p>
        </div>
    </div> -->
    <div class="row hover-with-grediant pointer" (click)="navigate('reminders')" *ngIf="isAdmin$()"
        [ngClass]="{'category-choose select-with-grediant': lastUrlSegment == 'reminders' }">
        <div class="name">
            <img class="icon scale-img" src="/assets/images/reminders.svg">
            <p translate>grid.navs.reminders</p>
        </div>
    </div>
    <div class="row hover-with-grediant pointer" (click)="navigate('savedLists')" *ngIf="isAdmin$()"
        [ngClass]="{'category-choose select-with-grediant': lastUrlSegment == 'savedLists' }">
        <div class="name">
            <img class="icon scale-img" src="/assets/images/saved-lists.svg">
            <p translate>grid.navs.savedLists</p>
        </div>
    </div>
    <div class="row hover-with-grediant pointer" (click)="navigate('approvals')"
        *ngIf="environment.featurs.approvalRequired == 'ON' && isDisplayApproval$()"
        [ngClass]="{'category-choose select-with-grediant': lastUrlSegment == 'approvals' }">
        <div class="name">
            <img class="icon scale-img" src="/assets/images/check_circle.svg">
            <p translate>grid.navs.approvals</p>
        </div>
        <span *ngIf="isApproverManager$() &&(countApprovals$() ?? 0 > 0)" class="approval-badge">
        {{countApprovals$()}}
        </span>
    </div>
</div>
<!-- <div class="row pointer" [ngClass]="{'category-choose':categoryId==0}"
            (click)="getRecentlyCreatedQustionnaries()">
            <div class="name">
                <img class="icon" src="/assets/images/recently-questionnaries-small-icon.svg">
                <p translate> search.recently</p>
            </div>
        </div> -->
<!-- <hr class="hr" /> -->
<!-- <div class="row pointer" *ngFor="let item of categories$()"
            [ngClass]="{'category-choose':categoryId==item.category.id}"
            (click)="getQuestionnairesByCategory(item.category)">
            <div class="name">
                <img class="icon" src="/assets/images/file.svg">
                <p translate [translateParams]="{ category: item.category}">grid.categoryName</p>
            </div>

            <div class="warp-open">
                <p class="count"> {{item.count}}</p>
            </div>
        </div> -->
<!-- lastUrlSegment == 'questionnairesList' -->